import React from "react";
import { ReactComponent as Logo } from "../../images/BakeSoc-Logo.svg";
import { LogoContainer } from "./Header.styles";

export const Header = () => {
  return (
    <LogoContainer>
      <a href={"/"}>
        <Logo />
      </a>
    </LogoContainer>
  );
};
